import React from "react";

import { Visibility } from "@material-ui/icons";
import { Box, IconButton, TextField, Typography } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";

const openHtmlInNewTab = (htmlContent) => {
  const newWindow = window.open();
  newWindow.document.open();
  newWindow.document.write(htmlContent);
  newWindow.document.close();
};

const TemplateAutocomplete = ({
  templates,
  selectedTemplate,
  setSelectedTemplate,
}) => {
  return (
    <Autocomplete
      options={templates}
      getOptionLabel={(option) => option.name}
      onChange={(event, selected) => {
        setSelectedTemplate(selected);
      }}
      disableClearable
      value={selectedTemplate}
      renderOption={(props, option) => (
        <Box
          component="li"
          {...props}
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
          }}
        >
          <Typography variant="body1">{props.name}</Typography>
          <IconButton
            onClick={(e) => {
              e.stopPropagation(); // Previene que seleccione la opción al hacer clic en el ojo
              openHtmlInNewTab(props.htmlContent);
            }}
            size="small"
            edge="end"
            aria-label="Ver HTML"
          >
            <Visibility fontSize="small" />
          </IconButton>
        </Box>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label={"Plantillas"}
          required
          variant="outlined"
        />
      )}
    />
  );
};

export default TemplateAutocomplete;
